import { useState, useEffect } from 'react';

import { motion } from 'framer-motion';

import { 

  MapPin, Phone, Mail, Clock, Send, Loader2, 

  CheckCircle, PhoneCall, Facebook

} from 'lucide-react';

const FACEBOOK_URL = 'https://share.google/epUDvbFg7W53pSQi8';

import { toast } from 'sonner';

import emailjs from '@emailjs/browser';

import Footer from '../components/Footer';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContactPage = () => {

  const [contactForm, setContactForm] = useState({

    name: '',

    email: '',

    phone: '',

    message: '',

    service_type: '',

  });

  const [callbackForm, setCallbackForm] = useState({

    name: '',

    phone: '',

    preferred_time: '',

    message: '',

  });

  const [loading, setLoading] = useState({ contact: false, callback: false });

  const [successMessage, setSuccessMessage] = useState(null);

  const CONTACT_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TARIFS_TEMPLATE_ID || process.env.REACT_APP_EMAILJS_CONTACT_TEMPLATE_ID || 'template_njb9erq';

  useEffect(() => {

    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    if (publicKey) {

      try {

        emailjs.init(publicKey);

        console.log('EmailJS initialized in ContactPage');

      } catch (e) {

        console.warn('EmailJS init failed in ContactPage', e);

      }

    } else {

      console.warn('REACT_APP_EMAILJS_PUBLIC_KEY not set (ContactPage)');

    }

  }, []);

  const handleContactSubmit = async (e) => {

    e.preventDefault();

    setLoading({ ...loading, contact: true });

    try {

      const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_6wrtsqj';

      const templateId = CONTACT_TEMPLATE_ID;

      const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

      if (!serviceId || !templateId || !publicKey) {

        toast.error('Configuration EmailJS manquante. Utilisez le mail manuel.');

        setLoading({ ...loading, contact: false });

        return;

      }

      const subject = contactForm.service_type ? `Demande: ${contactForm.service_type}` : 'Nouveau message depuis le site';

      // Map contact form fields to the estimation HTML template variables

      const serviceLabel = contactForm.service_type === 'electricite' ? 'Électricité'

        : contactForm.service_type === 'peinture' ? 'Peinture'

        : contactForm.service_type === 'revetement' ? 'Revêtements de sols'

        : contactForm.service_type === 'autre' ? 'Autre' : '';

      const templateParams = {

        selectedTarif: '',

        project_type: '',

        property_type: '',

        services: serviceLabel,

        surface: '',

        rooms: '',

        budget: '',

        urgency: '',

        from_name: contactForm.name,

        from_email: contactForm.email,

        phone: contactForm.phone,

        address: '',

        message: contactForm.message,

        to_email: 'aldroubi.brico@gmail.com',

        subject,

      };

      console.log('EmailJS send (Contact) - request:', { serviceId, templateId, templateParams });

      const res = await emailjs.send(serviceId, templateId, templateParams, publicKey);

      console.log('EmailJS send (Contact) - response:', res);

      toast.success('Message envoyé avec succès !');

      setContactForm({ name: '', email: '', phone: '', message: '', service_type: '' });

    } catch (err) {

      console.error('EmailJS contact send error:', err);

      try { await navigator.clipboard.writeText('aldroubi.brico@gmail.com'); toast.error('Envoi EmailJS échoué — adresse copiée. Ouverture du client mail...'); } catch (copyErr) { console.warn(copyErr); toast.error('Envoi EmailJS échoué — contactez aldroubi.brico@gmail.com'); }

      const mailto = `mailto:aldroubi.brico@gmail.com?subject=${encodeURIComponent(contactForm.service_type || 'Contact')} &body=${encodeURIComponent(contactForm.message || '')}`;

      window.location.href = mailto;

    } finally {

      setLoading({ ...loading, contact: false });

    }

  };

  const handleCallbackSubmit = async (e) => {

    e.preventDefault();

    setLoading({ ...loading, callback: true });

    try {

      const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_6wrtsqj';

      const templateId = CONTACT_TEMPLATE_ID;

      const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

      if (!serviceId || !templateId || !publicKey) {

        toast.error('Configuration EmailJS manquante. Utilisez le mail manuel.');

        setLoading({ ...loading, callback: false });

        return;

      }

      const subject = 'Demande de rappel';

      // Map callback request to the estimation template variables

      const templateParams = {

        selectedTarif: 'Demande de rappel',

        project_type: '',

        property_type: '',

        services: '',

        surface: '',

        rooms: '',

        budget: '',

        urgency: '',

        from_name: callbackForm.name,

        from_email: '',

        phone: callbackForm.phone,

        address: '',

        message: `${callbackForm.preferred_time ? 'Créneau: ' + callbackForm.preferred_time + '\n\n' : ''}${callbackForm.message || ''}`,

        to_email: 'aldroubi.brico@gmail.com',

        subject,

      };

      console.log('EmailJS send (Callback) - request:', { serviceId, templateId, templateParams });

      const res = await emailjs.send(serviceId, templateId, templateParams, publicKey);

      console.log('EmailJS send (Callback) - response:', res);

      toast.success('Demande de rappel enregistrée !');

      setCallbackForm({ name: '', phone: '', preferred_time: '', message: '' });

      setSuccessMessage('Nous vous rappellerons dans les plus brefs délais.');

    } catch (err) {

      console.error('EmailJS callback send error:', err);

      try { await navigator.clipboard.writeText('aldroubi.brico@gmail.com'); toast.error('Envoi EmailJS échoué — adresse copiée. Ouverture du client mail...'); } catch (copyErr) { console.warn(copyErr); toast.error('Envoi EmailJS échoué — contactez aldroubi.brico@gmail.com'); }

      const mailto = `mailto:aldroubi.brico@gmail.com?subject=${encodeURIComponent('Demande de rappel')}&body=${encodeURIComponent(callbackForm.message || '')}`;

      window.location.href = mailto;

    } finally {

      setLoading({ ...loading, callback: false });

    }

  };

  return (

    <div className="min-h-screen bg-[#050505] pt-24 pb-12" data-testid="contact-page">

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">

        {/* Header */}

        <div className="text-center mb-12 sm:mb-16">

          <span className="luxury-label">Contact</span>

          <h1 className="font-serif text-2xl sm:text-3xl md:text-4xl text-white mt-4">

            Parlons de Votre <span className="text-gold">Projet</span>

          </h1>

          <p className="text-gray-400 mt-4 max-w-xl mx-auto text-sm sm:text-base">

            Plusieurs moyens de nous contacter. Choisissez celui qui vous convient.

          </p>

        </div>

        {/* Contact Info Cards - Mise à jour */}

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4 mb-12 sm:mb-16">

          {/* Téléphone */}

          <div className="luxury-card p-4 sm:p-6 text-center">

            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gold/10 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">

              <Phone className="w-5 h-5 sm:w-6 sm:h-6 text-gold" />

            </div>

            <h3 className="text-white font-medium text-sm sm:text-base mb-1 sm:mb-2">Téléphone</h3>

            <a href="tel:0618709889" className="text-gold hover:underline text-xs sm:text-sm">06 18 70 98 89</a>

          </div>

          {/* Email */}

          <div className="luxury-card p-4 sm:p-6 text-center">

            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gold/10 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">

              <Mail className="w-5 h-5 sm:w-6 sm:h-6 text-gold" />

            </div>

            <h3 className="text-white font-medium text-sm sm:text-base mb-1 sm:mb-2">Email</h3>

            <a href="mailto:aldroubi.brico@gmail.com" className="text-gold hover:underline text-xs sm:text-sm break-all">

              aldroubi.brico@gmail.com

            </a>

          </div>

          {/* Facebook */}

          <a

            href={FACEBOOK_URL}

            target="_blank"

            rel="noopener noreferrer"

            className="luxury-card p-4 sm:p-6 text-center hover:bg-[#1877F2]/5 transition-colors group"

          >

            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#1877F2]/15 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4 group-hover:bg-[#1877F2]/30 transition-colors">

              <Facebook className="w-5 h-5 sm:w-6 sm:h-6 text-[#1877F2]" />

            </div>

            <h3 className="text-white font-medium text-sm sm:text-base mb-1 sm:mb-2">Facebook</h3>

            <span className="text-[#1877F2] text-xs sm:text-sm">Notre page</span>

          </a>

          {/* Instagram - Nouveau */}

          <a

            href="https://www.instagram.com/aldroubi_brico"

            target="_blank"

            rel="noopener noreferrer"

            className="luxury-card p-4 sm:p-6 text-center hover:bg-[#E1306C]/5 transition-colors group"

          >

            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#E1306C]/15 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4 group-hover:bg-[#E1306C]/30 transition-colors">

              {/* Utilisation d'un icône Instagram (vous pouvez importer Instagram depuis lucide-react) */}

              <svg className="w-5 h-5 sm:w-6 sm:h-6 text-[#E1306C]" fill="currentColor" viewBox="0 0 24 24">

                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.226.057 1.895.275 2.378.463.601.233 1.03.513 1.48.963.45.45.73.878.963 1.48.188.483.406 1.152.463 2.378.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.057 1.226-.275 1.895-.463 2.378-.233.601-.513 1.03-.963 1.48-.45.45-.878.73-1.48.963-.483.188-1.152.406-2.378.463-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.226-.057-1.895-.275-2.378-.463-.601-.233-1.03-.513-1.48-.963-.45-.45-.73-.878-.963-1.48-.188-.483-.406-1.152-.463-2.378-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.057-1.226.275-1.895.463-2.378.233-.601.513-1.03.963-1.48.45-.45.878-.73 1.48-.963.483-.188 1.152-.406 2.378-.463 1.266-.058 1.646-.07 4.85-.07zm0-2.163c-3.259 0-3.667.014-4.947.072-1.277.058-2.148.26-2.913.562-.79.307-1.458.72-2.126 1.388-.668.668-1.081 1.336-1.388 2.126-.302.765-.504 1.636-.562 2.913-.058 1.28-.072 1.688-.072 4.947 0 3.259.014 3.667.072 4.947.058 1.277.26 2.148.562 2.913.307.79 1.458 2.126 1.388 2.795-1.388.668-1.336.504-2.913.562-1.28.058-1.688.072-4.947.072-3.259 0-3.667-.014-4.947-.072-1.277-.058-2.148-.26-2.913-.562-.79-.307-1.458-.72-2.126-1.388-.668-.668-1.081-1.336-1.388-2.126-.302-.765-.504-1.636-.562-2.913-.058-1.28-.072-1.688-.072-4.947 0-3.259.014-3.667.072-4.947.058-1.277.26-2.148.562-2.913.307-.79.72-1.458 1.388-2.126.668-.668 1.336-1.081 2.126-1.388.765-.302 1.636-.504 2.913-.562 1.28-.058 1.688-.072 4.947-.072zM12 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.162 6.162 6.162 6.162-2.759 6.162-6.162-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.441 0 .796.645 1.441 1.441 1.441.796 0 1.441-.645 1.441-1.441 0-.796-.645-1.441-1.441-1.441z"/>

              </svg>

            </div>

            <h3 className="text-white font-medium text-sm sm:text-base mb-1 sm:mb-2">Instagram</h3>

            <span className="text-[#E1306C] text-xs sm:text-sm">Nos réalisations</span>

          </a>

          {/* Zone */}

          <div className="luxury-card p-4 sm:p-6 text-center">

            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gold/10 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">

              <MapPin className="w-5 h-5 sm:w-6 sm:h-6 text-gold" />

            </div>

            <h3 className="text-white font-medium text-sm sm:text-base mb-1 sm:mb-2">Zone</h3>

            <p className="text-gray-400 text-xs sm:text-sm">Normandie</p>

          </div>

          {/* Disponibilité */}

          <div className="luxury-card p-4 sm:p-6 text-center">

            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">

              <Clock className="w-5 h-5 sm:w-6 sm:h-6 text-green-400" />

            </div>

            <h3 className="text-white font-medium text-sm sm:text-base mb-1 sm:mb-2">Disponibilité</h3>

            <p className="text-green-400 text-xs sm:text-sm font-medium">24h/24 - 7j/7</p>

          </div>

        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8">

          {/* Contact Form */}

          <div className="luxury-card p-6 sm:p-8">

            <h2 className="font-serif text-xl sm:text-2xl text-white mb-4 sm:mb-6 flex items-center gap-3">

              <Send className="w-5 h-5 sm:w-6 sm:h-6 text-gold" />

              Envoyez-nous un message

            </h2>

            <form onSubmit={handleContactSubmit} className="space-y-4 sm:space-y-5">

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

                <div>

                  <label className="luxury-label">Nom</label>

                  <input

                    type="text"

                    value={contactForm.name}

                    onChange={(e) => setContactForm({ ...contactForm, name: e.target.value })}

                    className="luxury-input"

                    placeholder="Jean Dupont"

                    required

                    data-testid="contact-name"

                  />

                </div>

                <div>

                  <label className="luxury-label">Téléphone</label>

                  <input

                    type="tel"

                    value={contactForm.phone}

                    onChange={(e) => setContactForm({ ...contactForm, phone: e.target.value })}

                    className="luxury-input"

                    placeholder="06 12 34 56 78"

                    required

                    data-testid="contact-phone"

                  />

                </div>

              </div>

              <div>

                <label className="luxury-label">Email</label>

                <input

                  type="email"

                  value={contactForm.email}

                  onChange={(e) => setContactForm({ ...contactForm, email: e.target.value })}

                  className="luxury-input"

                  placeholder="jean@exemple.fr"

                  required

                  data-testid="contact-email"

                />

              </div>

              <div>

                <label className="luxury-label">Service concerné</label>

                <select

                  value={contactForm.service_type}

                  onChange={(e) => setContactForm({ ...contactForm, service_type: e.target.value })}

                  className="luxury-input"

                  data-testid="contact-service"

                >

                  <option value="">Sélectionnez...</option>

                  <option value="electricite">Électricité</option>

                  <option value="peinture">Peinture</option>

                  <option value="revetement">Revêtements</option>

                  <option value="autre">Autre</option>

                </select>

              </div>

              <div>

                <label className="luxury-label">Message</label>

                <textarea

                  value={contactForm.message}

                  onChange={(e) => setContactForm({ ...contactForm, message: e.target.value })}

                  rows={4}

                  className="luxury-input resize-none"

                  placeholder="Décrivez votre projet..."

                  required

                  data-testid="contact-message"

                />

              </div>

              <button

                type="submit"

                disabled={loading.contact}

                className="w-full btn-gold flex items-center justify-center gap-2"

                data-testid="contact-submit"

              >

                {loading.contact ? (

                  <Loader2 className="w-4 h-4 animate-spin" />

                ) : (

                  <>

                    Envoyer

                    <Send className="w-4 h-4" />

                  </>

                )}

              </button>

            </form>

          </div>

          {/* Callback Request */}

          <div className="luxury-card p-6 sm:p-8">

            <h2 className="font-serif text-xl sm:text-2xl text-white mb-4 sm:mb-6 flex items-center gap-3">

              <PhoneCall className="w-5 h-5 sm:w-6 sm:h-6 text-gold" />

              Demander un rappel

            </h2>

            {successMessage ? (

              <div className="text-center py-8">

                <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-4" />

                <p className="text-white">{successMessage}</p>

                <button

                  onClick={() => setSuccessMessage(null)}

                  className="btn-gold-outline mt-4"

                >

                  Nouvelle demande

                </button>

              </div>

            ) : (

              <form onSubmit={handleCallbackSubmit} className="space-y-4">

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

                  <div>

                    <label className="luxury-label">Nom</label>

                    <input

                      type="text"

                      value={callbackForm.name}

                      onChange={(e) => setCallbackForm({ ...callbackForm, name: e.target.value })}

                      className="luxury-input"

                      required

                      data-testid="callback-name"

                    />

                  </div>

                  <div>

                    <label className="luxury-label">Téléphone</label>

                    <input

                      type="tel"

                      value={callbackForm.phone}

                      onChange={(e) => setCallbackForm({ ...callbackForm, phone: e.target.value })}

                      className="luxury-input"

                      required

                      data-testid="callback-phone"

                    />

                  </div>

                </div>

                <div>

                  <label className="luxury-label">Créneau préféré</label>

                  <select

                    value={callbackForm.preferred_time}

                    onChange={(e) => setCallbackForm({ ...callbackForm, preferred_time: e.target.value })}

                    className="luxury-input"

                    data-testid="callback-time"

                  >

                    <option value="">Peu importe</option>

                    <option value="matin">Matin (8h-12h)</option>

                    <option value="apres-midi">Après-midi (14h-18h)</option>

                    <option value="soir">Soir (18h-20h)</option>

                  </select>

                </div>

                <div>

                  <label className="luxury-label">Motif (optionnel)</label>

                  <textarea

                    value={callbackForm.message}

                    onChange={(e) => setCallbackForm({ ...callbackForm, message: e.target.value })}

                    rows={2}

                    className="luxury-input resize-none"

                    placeholder="De quoi s'agit-il ?"

                  />

                </div>

                <button

                  type="submit"

                  disabled={loading.callback}

                  className="w-full btn-gold flex items-center justify-center gap-2"

                  data-testid="callback-submit"

                >

                  {loading.callback ? (

                    <Loader2 className="w-4 h-4 animate-spin" />

                  ) : (

                    <>

                      Demander un rappel

                      <PhoneCall className="w-4 h-4" />

                    </>

                  )}

                </button>

              </form>

            )}

            {/* Zone d'intervention */}

            <div className="mt-8 p-4 sm:p-6 bg-gold/5 border border-gold/20 rounded-lg">

              <h3 className="text-gold font-medium mb-3 flex items-center gap-2">

                <MapPin className="w-5 h-5" />

                Zone d'intervention

              </h3>

              <p className="text-gray-300 text-sm mb-3">

                Nous intervenons sur <span className="text-white font-medium">Argentan, Caen</span> et 

                dans toute la normandie.

              </p>

              <p className="text-gray-400 text-xs">

                Villes desservies : Argentan, Flers, Alençon, Sées, Falaise, Caen, Deauville et environs.

              </p>

            </div>

          </div>

        </div>

        {/* Google Maps */}
        <section className="mt-12 sm:mt-16">
          <div className="text-center mb-6">
            <span className="luxury-label">Localisation</span>

            <h2 className="font-serif text-2xl sm:text-3xl text-white mt-3">
              Retrouvez-nous à <span className="text-gold">Argentan</span>
            </h2>

            <p className="text-gray-400 mt-3">
              Consultez notre localisation et prenez rendez-vous directement.
            </p>

            <a
              href="/rendez-vous"
              className="btn-gold inline-flex items-center justify-center mt-5"
            >
              Prendre rendez-vous
            </a>
          </div>

          <div className="w-full h-[450px] sm:h-[550px] overflow-hidden rounded-xl border border-gold/20">
            <iframe
              src="https://storage.googleapis.com/maps-solutions-ipex6ctcq2/locator-plus/6wux/locator-plus.html"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
              title="ALDROUBI Brico - Localisation"
            />
          </div>
        </section>

      </div>

      <div className="mt-24">

        <Footer />

      </div>

    </div>

  );

};

export default ContactPage;
